'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onShow", "onHide", "withPortal"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { deprecatedOverlayDirections } from "../../styles/mixins/index.mjs";
import { OverlayTrigger } from "../OverlayTrigger/index.mjs";
import styled from "../../styled-components.mjs";
var TriggerContainer = styled.span.withConfig({
  displayName: "TooltipTrigger__TriggerContainer",
  componentId: "sc-13ojzs2-0"
})(["display:inline-flex;"]);
var TooltipTriggerComponent = /*#__PURE__*/React.forwardRef(function TooltipTriggerComponent(_ref, ref) {
  var children = _ref.children,
    _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? function () {} : _ref$onShow,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
    withPortal = _ref.withPortal,
    props = _objectWithoutProperties(_ref, _excluded);
  var triggerRef = React.useRef(null);
  var timeoutId = null;
  var handleOnHide = function handleOnHide(e) {
    onHide(e);
    if (timeoutId) {
      window.clearTimeout(timeoutId);
      timeoutId = null;
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    var escape = 27;
    if (e.which === escape) {
      onHide(e);
    }
  };
  useEffect(function () {
    return function () {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);
  var mouseEvents = {};
  var mouseShowEvent = 'onMouseOver';
  var mouseHideEvent = 'onMouseOut';
  /* we can make PointerEvents default when we drop Safari 12.1 support */
  if (typeof window !== 'undefined' && 'PointerEvent' in window) {
    mouseShowEvent = 'onPointerEnter';
    mouseHideEvent = 'onPointerLeave';
  }
  mouseEvents[mouseShowEvent] = onShow;
  mouseEvents[mouseHideEvent] = handleOnHide;
  return /*#__PURE__*/React.createElement(OverlayTrigger, Object.assign({}, props, {
    withPortal: withPortal,
    ref: withPortal ? ref || triggerRef : null,
    closeOverlay: handleOnHide,
    "data-encore-id": ENCORE_DATA_IDS.TooltipTrigger
  }), /*#__PURE__*/React.createElement(TriggerContainer, Object.assign({}, mouseEvents, {
    onFocus: onShow,
    onBlur: handleOnHide,
    onKeyDown: handleKeyDown
  }), children));
});
var tooltipTriggerHelpers = _objectSpread({}, deprecatedOverlayDirections);

/**
* **TooltipTrigger** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TooltipTrigger) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=511:65)
*
* Our Triggers are not viewport-aware and may render off screen in more dynamic situations. Consider a library such as [Tippy.mjs](https://atomiks.github.io/tipp.mjs/) or [Floating UI](https://floating-ui.com/) if you need smarter positioning.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/non-visual?format=figma-figma#tooltiptrigger)
*
* @example
* () => {
*  const [show, toggleShow] = useState(false);
*
*  return (
*    <TooltipTrigger
*      overlay={show && <Tooltip id="notifications">Notifications</Tooltip>}
*      placement="end"
*      onShow={() => toggleShow(true)}
*      onHide={() => toggleShow(false)}
*    >
*      <ButtonTertiary
*        condensedAll
*        size="large"
*        iconOnly={IconNotifications}
*        aria-labelledby="notifications"
*      />
*    </TooltipTrigger>
*  );
*};
*
*/
export var TooltipTrigger = Object.assign(TooltipTriggerComponent, tooltipTriggerHelpers);